<template>
  <AnswerTips @loaded="onLoaded" hiddenTitle questionPageName="KaspiRed" />
</template>

<script>
import AnswerTips from "@/components/shared/tips/AnswerTips";

export default {
  name: "RedTips",
  components: { AnswerTips },
  created() {
    this.$store.dispatch("system/setLoaderStatus", true);
    this.$logAnalyticEvent("mybank_red_guide", {
      page_path: "/bank/red/tips",
    });
  },
  methods: {
    onLoaded() {
      this.$store.dispatch("system/setLoaderStatus", false);
    },
  },
};
</script>
